module.exports = __webpack_public_path__ + "assets/img/text-step02.svg";